/* eslint-disable react/prop-types */
/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable react/jsx-no-bind */
/* eslint import/no-cycle: [1, { maxDepth: 1 }] */
import {
  useState, useCallback, useContext, useEffect, memo,
} from 'react';
// ALL MATERIAL UI COMPONENTS AND THEME
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid,
  IconButton,
  Modal,
  Fade,
  useMediaQuery,
} from '@material-ui/core';
import Cookies from 'js-cookie';
// IMPORTING ICONS
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { UserContext } from '@context/UserContext';
// IMPORT EXTERNAL CSS
import './LoginModal.css';

import LoginOptions from '@features/Authentication/components/LoginOptions/LoginOptions';
import LoginViaQR from '@features/Authentication/components/LoginViaQR/LoginViaQR';
import LoginViaUsername from '@features/Authentication/components/LoginViaUsername/LoginViaUsername';
import ReCaptcha from '@features/Authentication/components/ReCaptcha/ReCaptcha';

import LockUser from '@features/UserAccountLock';
import BanUser from '@features/UserAccountBan';

// Styles for Login Modal using material ui
const useStyles = makeStyles((theme) => ({
  loginModal: {
    position: 'absolute',
    height: 588,
    maxWidth: 600,
    minWidth: 600,
    overflowY: 'hidden',
    overflowX: 'hidden',
    background: 'linear-gradient(137.62deg, #04043B 0%, #280548 61.29%)',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 20,
    borderColor: 'transparent',
    outline: 0,
    [theme.breakpoints.down('xs')]: {
      height: '100%',
      minWidth: '100%',
      position: 'fixed',
      margin: '0px',
      padding: theme.spacing(10, 4, 3),
      borderRadius: 0,
    },
    [theme.breakpoints.down('sm')]: {
      '@media (orientation: landscape)': {
        margin: '120px 0',
      },
    },
    [theme.breakpoints.down('md')]: {
      '@media (orientation: landscape)': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
      },
    },
    [theme.breakpoints.up('lg')]: {
      '@media (orientation: landscape)': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
      },
    },
    [theme.breakpoints.up('lg')]: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    },
  },
  captchaModal: {
    position: 'absolute',
    height: 588,
    maxWidth: 600,
    minWidth: 600,
    overflowX: 'hidden',
    [theme.breakpoints.up('lg')]: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    },
    [theme.breakpoints.up('lg')]: {
      '@media (orientation: landscape)': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        overflowY: 'auto',
      },
    },
    [theme.breakpoints.down('md')]: {
      '@media (orientation: landscape)': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        overflowY: 'auto',
      },

    },
    [theme.breakpoints.down('sm')]: {
      '@media (orientation: landscape)': {
        margin: '120px 0',
        overflowY: 'auto',

      },
    },
    [theme.breakpoints.down('xs')]: {
      height: '100%',
      minWidth: '100%',
      position: 'fixed',
      margin: '0px',
      padding: theme.spacing(10, 4, 3),
      borderRadius: 0,
      overflowY: 'auto',
    },
  },
  loginModalHeader: {
    color: '#FB2961',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
  },
  loginModalDescription: {
    color: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '10pt',
    [theme.breakpoints.down('xs')]: {
      fontSize: '7pt',
    },
  },
  expireQr: {
    [theme.breakpoints.up('md')]: {
      width: '80% !important',
    },
  },
}));

// eslint-disable-next-line react/prop-types
function LoginModal({
  isOpenModal,
  modalFunc,
  showMenuOption,
  setMenuOption,
  isOpenReCaptcha = false,
  setLoadingLogin,
}) {
  // import the custom styles from useStyles
  const classes = useStyles();

  // theme from material ui
  const theme = useTheme();

  // responsive states
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('xs'));

  // modal states
  const [openModal, setOpenModal] = useState(isOpenModal);
  const [isReCaptcha, setIsReCaptcha] = useState(isOpenReCaptcha);
  const [noReCaptchaCheck, setNoReCaptchaCheck] = useState(false);

  useEffect(() => {
    const recaptchaWindow = [
      ...document.getElementsByTagName('iframe'),
    ]?.find((x) => x.src.includes('google.com/recaptcha/api2/bframe'))?.parentNode?.parentNode;
    if (recaptchaWindow) {
      recaptchaWindow.remove();
    }
  }, []);

  // closing modal function
  const closeModal = () => {
    setOpenModal(!openModal);
    setIsReCaptcha(false);
    setNoReCaptchaCheck(false);
    modalFunc({
      modalStatus: !openModal,
      counterStatus: 0,
      setReloadQr: false,
    });
    const recaptchaWindow = [
      ...document.getElementsByTagName('iframe'),
    ]?.find((x) => x.src.includes('google.com/recaptcha/api2/bframe'))?.parentNode?.parentNode;
    if (recaptchaWindow) {
      recaptchaWindow.remove();
    }
  };

  const { loggedIn, setLoggedIn } = useContext(UserContext); // profile data - store
  const getLoggedInAction = useCallback((data) => {
    setLoggedIn(data.loggedIn);
  }, [loggedIn, openModal]);

  const modalActions = useCallback((data) => {
    if (data.modalStatus) {
      const modalVal = openModal;
      setOpenModal(modalVal);
    } else {
      closeModal();
      setMenuOption(false);
    }
  }, [openModal]);

  const [subLabelText, setSubLabelText] = useState('');
  const [agreedStatus, setAgreedStatus] = useState(false);
  const [checked, setChecked] = useState(false);
  const handleAgreement = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setAgreedStatus(true);
      setSubLabelText('');
      setChecked(true);
      Cookies.set('agreedStatus', true, { expires: 90, secure: true });
    } else {
      setAgreedStatus(false);
      setChecked(false);
      Cookies.remove('agreedStatus');
    }
  };
  const [showLoginOptions, setShowLoginOptions] = useState(true);
  const [showLoginViaUsername, setShowLoginViaUsername] = useState(false);
  const [showLoginViaQR, setShowLoginViaQR] = useState(false);
  const [showLoginViaGoogle, setShowLoginViaGoogle] = useState(false);
  const [showLoginViaApple, setShowLoginViaApple] = useState(false);
  const [mainCopy, setMainCopy] = useState('Log in to kumu');
  const [checkUsernameFormPage, setcheckUsernameFormPage] = useState('');
  const [subLabelTextUsername, setSubLabelTextUsername] = useState('Enter your kumu username below');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessasge] = useState('');

  const backToLoginOptions = () => {
    if (showLoginViaQR) {
      setShowLoginOptions(true);
      setShowLoginViaQR(false);
    }
    if (showLoginViaUsername) {
      if (checkUsernameFormPage === 'otpField') {
        setcheckUsernameFormPage('usernameField');
        setSubLabelTextUsername('Enter your kumu username below');
        setShowErrorMessage(false);
        setErrorMessasge('');
        const divUsername = document.getElementById('username-form');
        const divOtp = document.getElementById('otp-form');
        divUsername.style.opacity = 0;
        divOtp.addEventListener('animationend', (e) => {
          if (e.animationName === 'move-to-right') {
            divOtp.classList.remove('move-to-right');
            divOtp.style.display = 'none';
            divUsername.classList.add('move-back');
            divUsername.style.display = 'flex';
          }
        });
        divOtp.classList.add('move-to-right');
        divUsername.addEventListener('animationend', (e) => {
          if (e.animationName === 'move-back') {
            divUsername.classList.remove('move-back');
            divUsername.style.opacity = 1;
          }
        });
      } else if (checkUsernameFormPage === 'usernameField') {
        setShowLoginOptions(true);
        setShowLoginViaUsername(false);
      }
    }
  };

  function loginViaUsername() {
    setShowLoginOptions(false);
    setShowLoginViaUsername(true);
    // segment tracking
    if (process.env.REACT_APP_ON_SEGMENT === 'true') {
      window.analytics.track('Login Method Selected', {
        login_method: 'Username',
      });
    }
  }

  function loginViaQR() {
    setShowLoginOptions(false);
    setShowLoginViaQR(true);
    // segment tracking
    if (process.env.REACT_APP_ON_SEGMENT === 'true') {
      window.analytics.track('Login Method Selected', {
        login_method: 'QR',
      });
    }
  }

  function loginViaGoogle() {
    // segment tracking
    setShowLoginViaGoogle(true);
    if (process.env.REACT_APP_ON_SEGMENT === 'true') {
      window.analytics.track('Login Method Selected', {
        login_method: 'Google',
      });
    }
  }

  function loginViaApple() {
    setShowLoginViaApple(true);
    // segment tracking
    if (process.env.REACT_APP_ON_SEGMENT === 'true') {
      window.analytics.track('Login Method Selected', {
        login_method: 'Apple',
      });
    }
  }

  function loginOptions() {
    if (showLoginViaUsername) {
      setShowLoginViaUsername(false);
    } else if (showLoginViaQR) {
      setShowLoginViaQR(false);
    }
    setShowLoginOptions(true);
    setSubLabelText('');
  }

  function googleError() {
    const googleErrorMessage = 'This account is not yet registered or connected to kumu. Please try a different login method';
    setMainCopy('Sorry, that didn\'t work. Try a different option?');
    // login failed segment event
    window.analytics.track('Login Failed', {
      login_method: 'Google',
      error_message: googleErrorMessage,
    });
  }

  function appleError() {
    const appleErrorMessage = 'This account is not yet registered or connected to kumu. Please try a different login method';
    setMainCopy('Sorry, that didn\'t work. Try a different option?');
    if (process.env.REACT_APP_ON_SEGMENT === 'true') {
      // login failed segment event
      window.analytics.track('Login Failed', {
        login_method: 'Apple',
        error_message: appleErrorMessage,
      });
    }
  }
  // ban and lock
  const [banModalStatus, setBanModalStatus] = useState(false);
  const [userBanDetails, setUserBanDetails] = useState([]);

  let loginScreen = null;
  if (showLoginOptions) {
    loginScreen = (
      <LoginOptions
        loginViaUsername={loginViaUsername}
        loginViaQR={loginViaQR}
        handleAgreement={handleAgreement}
        subLabelText={subLabelText}
        checked={checked}
        modalFunc={modalActions}
        loggedInFunc={getLoggedInAction}
        banModalStatusFunc={setBanModalStatus}
        setBanDetailsFunc={setUserBanDetails}
        agreedStatus={agreedStatus}
        setSubLabelText={setSubLabelText}
        showLoginViaGoogle={showLoginViaGoogle}
        loginViaGoogle={loginViaGoogle}
        googleError={googleError}
        showLoginViaApple={showLoginViaApple}
        loginViaApple={loginViaApple}
        appleError={appleError}
        mainCopy={mainCopy}
        setMainCopy={setMainCopy}
        noReCaptchaCheck={noReCaptchaCheck}
      />
    );
  } else if (showLoginViaUsername) {
    loginScreen = (
      <LoginViaUsername
        loginOptions={loginOptions}
        modalFunc={modalActions}
        loggedInFunc={getLoggedInAction}
        setMenuOption={setMenuOption}
        setcheckUsernameFormPage={setcheckUsernameFormPage}
        subLabelTextUsername={subLabelTextUsername}
        setSubLabelTextUsername={setSubLabelTextUsername}
        errorMessage={errorMessage}
        setErrorMessasge={setErrorMessasge}
        showErrorMessage={showErrorMessage}
        setShowErrorMessage={setShowErrorMessage}
      />
    );
  } else if (showLoginViaQR) {
    loginScreen = (
      <LoginViaQR
        loginOptions={loginOptions}
        modalFunc={modalActions}
        loggedInFunc={getLoggedInAction}
      />
    );
  }

  // eslint-disable-next-line consistent-return
  const renderBanOrLockModal = () => {
    if (banModalStatus.lockModal === true) {
      return (<LockUser banModalStatus={banModalStatus.lockModal} />);
    } else if (userBanDetails.length !== 0) {
      return (<BanUser banModalStatus={banModalStatus.banModal} userBanDetails={userBanDetails} />);
    }
  };

  return (
    <>
      <div
        className={[classes.captchaModal]}
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <ReCaptcha
          setIsReCaptcha={setIsReCaptcha}
          setNoReCaptchaCheck={setNoReCaptchaCheck}
          showMenuOption={showMenuOption}
          setMenuOption={setMenuOption}
          setLoadingLogin={setLoadingLogin}
        />
      </div>
      <Modal
        open={isReCaptcha && openModal}
        onClose={closeModal}
        aria-labelledby='login-modal'
        aria-describedby='login-modal-description'
        className='login-modal'
        disableEscapeKeyDown
      >
        <Fade in={isOpenModal}>
          <div className={classes.loginModal} style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} id='main-login-modal'>
            <Grid
              container
              spacing={1}
              style={isExtraSmall ? {
                marginBottom: '5px',
                alignItems: 'center',
              } : { marginBottom: '10px' }}
              alignItems='center'
            >
              <div style={{ position: 'fixed', top: 60 }}>
                {showLoginViaQR || showLoginViaUsername
                  ? (
                    <Grid className='back-btn-container'>
                      <IconButton role='back-btn' onClick={backToLoginOptions} disableRipple>
                        <ArrowBackIcon className='back-icon' style={{ color: '#fff' }} />
                      </IconButton>
                    </Grid>
                  )
                  : '' }
                <Grid className='close-btn-container'>
                  <IconButton role='close-btn' onClick={closeModal} disableRipple>
                    <CloseIcon className='close-icon' style={{ color: '#fff' }} />
                  </IconButton>
                </Grid>
              </div>
              {loginScreen}

            </Grid>
          </div>
        </Fade>
      </Modal>

      {renderBanOrLockModal()}
    </>

  );
}

export default memo(LoginModal);
